"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardType = void 0;
var CardType;
(function (CardType) {
    CardType["VISA"] = "VISA";
    CardType["MASTERCARD"] = "MASTERCARD";
    CardType["AMEX"] = "AMEX";
    CardType["DISCOVER"] = "DISCOVER";
})(CardType = exports.CardType || (exports.CardType = {}));
//# sourceMappingURL=payment.js.map